import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import {
  Box,
  CircularProgress,
  Typography,
  Container,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const Callback = () => {
  const { isLoading, error, isAuthenticated, user } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    // Auth0Provider normally consumes appState and navigates first. This is only
    // a synchronous fallback when a successful callback is still mounted.
    if (isAuthenticated && user && !isLoading) {
      navigate("/dashboard", { replace: true });
    }
  }, [isAuthenticated, user, isLoading, navigate]);

  if (error) {
    return (
      <Container maxWidth="sm">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            textAlign: "center",
          }}
        >
          <Typography variant="h5" color="error" gutterBottom>
            Authentication Error
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            {error.message || "An error occurred during authentication"}
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate("/")}
            sx={{ textTransform: "none" }}
          >
            Return to Home
          </Button>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          textAlign: "center",
        }}
      >
        <CircularProgress size={60} sx={{ mb: 3 }} />
        <Typography variant="h5" gutterBottom>
          Signing you in...
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Please wait while we complete your authentication
        </Typography>
      </Box>
    </Container>
  );
};

export default Callback;
